export const resolutions = [
  {
    value: 'all',
    text: 'labels.allResolutions',
  },
  {
    value: 'low',
    text: 'labels.lowResolution',
  },
  {
    value: 'high',
    text: 'labels.highResolution',
  },
];
